module.exports = __webpack_public_path__ + "static/pic02-a7baf04e8614d571150c79e934b3cb9f.png";